import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from './Context/UserContext';
import { Table, Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import "../styles/ViewAllVendorsDeptHead.css";
import { Link } from "react-router-dom";
import profileImg from "../assets/logo.png";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "../../src/components/DashboardLayout";

const ViewAllVendorsDeptHead = () => {
    const [approvalHistory, setApprovalHistory] = useState([]); // Change the state name here
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { user } = useUser();
    const [showCard, setShowCard] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("details");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [approvalStatuses, setApprovalStatuses] = useState([]);
    const [comment, setComment] = useState("");
    const [approvalError, setApprovalError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [subTab, setSubTab] = useState("details");
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [isSaved, setIsSaved] = useState(false);
    const [approverId, setApproverId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const { user: loggedInUser } = useUser();
    const [latestApproval, setLatestApproval] = useState(null);
    const [showSaveBtn, setShowSaveBtn] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [departmentHeads, setDepartmentHeads] = useState([]);
    const [departmentHeadError, setDepartmentHeadError] = useState("");
    const [departmentTypeError, setDepartmentTypeError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(3);
    const [backendStatus, setBackendStatus] = useState("Pending");
    const isReadOnly = backendStatus === "1" || backendStatus === "2";

    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);

    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);


   
    useEffect(() => {
        console.log("Selected Vendor:", selectedVendor);

        if (selectedVendor && selectedVendor.userId) {
            axios
                /*.get(`/api/approvalstatus/${selectedVendor.userId}`)*/
                .get(`/api/approvalstatus/status/${selectedVendor.id}`)
                .then(response => {
                    console.log("Approval History Data:", response.data);
                    setUsers(response.data || []);
                })
                .catch(error => {
                    console.error("Error fetching approval status:", error);
                });
        }
    }, [selectedVendor]);

    const filteredVendors = vendors.filter(vendor =>
        vendor.nameOfCompany?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const usersPerPage = 6; // Only 6 users per page
    const vendorsPerPage = 6;
    const startIndex = (currentPage - 1) * vendorsPerPage;
    const endIndex = startIndex + vendorsPerPage;
    const totalPages = Math.ceil(vendors.length / vendorsPerPage);
    const vendorsForPage = filteredVendors.slice(startIndex, endIndex);
   
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "Invalid Date";
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    };
    const handlePageChange = (type) => {
        if (type === "first") setCurrentPage(1);
        if (type === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
        if (type === "next" && currentPage < totalPages) setCurrentPage(currentPage + 1);
        if (type === "last") setCurrentPage(totalPages);
    };
    console.log("Clicked user:", user);
    const handleReviewClick = (index) => {

        const vendor = vendors[index]; // ✅ Declare vendor first
        console.log("Clicked vendor:", vendor); //  Helps confirm structure

        setSelectedVendor({
            ...vendor,
            userId: vendor.userId || vendor.UserId || vendor.userid || vendor.id || null, // ✅ Ensure correct userId
            index
        });

        setShowModal(true);
        setIsEditing(false);
        setActiveTab("history");
    };

    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };

   
    const handleSort = (column) => {
        const sortedVendors = [...vendors].sort((a, b) => {
            let valueA, valueB;

            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }

            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });
        setVendors(sortedVendors);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const res = await axios.get("/department/departments"); 
                console.log("Departments fetched:", res.data);
                setDepartments(res.data);
            } catch (err) {
                console.error("Failed to load departments", err);
            }
        };
        fetchDepartments();
    }, []);

    useEffect(() => {
        if (!selectedVendor?.departmentType) {
            setDepartmentHeads([]);
            return;
        }

        axios
            .get(`/department/department-heads/${selectedVendor.departmentType}`)
            .then((res) => {
                setDepartmentHeads(res.data);
                setSelectedVendor((prev) => {
                    const valid = res.data.some(
                        (head) => String(head.empId) === String(prev.departmentHead)
                    );
                    return valid ? prev : { ...prev, departmentHead: "" };
                });
            })
            .catch((err) => console.error("Failed to load department heads", err));
    }, [selectedVendor?.departmentType]);

    useEffect(() => {
        const fetchVendors = async () => {
            if (!loggedInUser?.empId) {
                console.warn("Emp ID not yet loaded");
                return;
            }

            setLoading(true);
            try {
                const res = await axios.get(
                    "/api/vendordetails/details-depthead-byid",
                    {
                        params: {
                            statusId: selectedStatus,
                            empId: loggedInUser.empId, // ✅ pass empId explicitly
                            search: "" // required for backend, even empty
                        }
                    }
                );
                setVendors(res.data);
            } catch (err) {
                console.error("Error fetching vendors:", err);
                setVendors([]);
            } finally {
                setLoading(false);
            }
        };

        fetchVendors();
    }, [selectedStatus, loggedInUser?.empId]);


    const statusMapping = {
        Pending: 3,    // pStatusID = 3 → Pending
        Rejected: 2,   // pStatusID = 2 → Rejected
        Approved: 1    // pStatusID = 1 → Approved
    };

    const mapBackendStatusToUI = (status) => {
        if (status === 7) return "Approved";
        if (status === 5 || status === 6) return "Rejected";
        return "Pending";
    };

    const mapRejectionSendToFromStatus = (approvalStatus) => {
        if (approvalStatus === 5) return "4"; // PO
        if (approvalStatus === 6) return "5"; // Vendor
        return "";
    };

    useEffect(() => {
        if (!selectedVendor?.id || !approverId || !showModal) return;

        axios.get("/api/approvalstatus/vendor-latest-approval", {
            params: { vendorId: selectedVendor.id, approvalId: approverId }
        })
            .then(res => {
                const data = res.data;
                console.log("✅ API Response:", data);
                
                const uiStatus = mapBackendStatusToUI(data.approvalStatus); 
                setBackendStatus(uiStatus); 
                
                setSelectedVendor(prev => ({
                    ...prev,
                    // Only update dept fields when vendor is NOT pending
                    departmentType: uiStatus !== "Pending" ? data.dept_ID : prev?.departmentType,
                    departmentName: uiStatus !== "Pending" ? data.departmentName : prev?.departmentName,
                    departmentHead: uiStatus !== "Pending" ? data.dept_headID : prev?.departmentHead,
                    departmentHeadName: uiStatus !== "Pending" ? data.deptHeadName : prev?.departmentHeadName,
                    // Always update approval status
                    approvalStatus: uiStatus,
                    comments: data.approvalComments || "",
                    rejectionSendTo: uiStatus === "Rejected" ? mapRejectionSendToFromStatus(data.approvalStatus) : "",
                    isReadOnly: uiStatus === "Approved" || uiStatus === "Rejected"
                }));

                setComment(data.approvalComments || ""); // sync comment state
                setShowSaveBtn(uiStatus !== "Approved" && uiStatus !== "Rejected");
            })
            .catch(err => console.error(err));
    }, [selectedVendor?.id, approverId, !showModal]);

    const handleSave = async () => {
        if (isReadOnly) {
            console.warn("Read-only mode: No updates allowed");
            return;
        }
        let isValid = true;
        if (String(selectedVendor?.approvalStatus) !== "Approved" &&
            String(selectedVendor?.approvalStatus) !== "Rejected") {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }

        if (!selectedVendor?.comments || selectedVendor.comments.trim() === "") {
            setCommentError("Comment is required");
            isValid = false;
        }

        if (!selectedVendor?.userId) {
            console.error("Missing vendor user ID");
            isValid = false;
        }

        if (selectedVendor?.approvalStatus === "Rejected" && !selectedVendor?.rejectionSendTo) {
            setRejectionSendToError("Please select a role to send rejection to");
            isValid = false;
        }

        if (!approverId) {
            alert("Approver ID not yet loaded. Please wait and try again.");
            isValid = false;
        }

        if (!isValid) return;
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");
        let approvalStatus = null;

        if (selectedVendor.approvalStatus === "Approved") {
            approvalStatus = 7; // Approved by Dept Head
        } else if (selectedVendor.approvalStatus === "Rejected") {
            if (parseInt(selectedVendor.rejectionSendTo) === 4) {
                approvalStatus = 5; // Rejected, Sent to PO
            } else if (parseInt(selectedVendor.rejectionSendTo) === 5) {
                approvalStatus = 6; // Rejected, Sent to Dept Head
            } else {
                alert("Invalid rejection role selected");
                return;
            }
        }
        const payload = {
            VendorId: selectedVendor.id,
            ApprovalStatus: approvalStatus,
            Comments: selectedVendor.comments,
            ApproverId: approverId,
            SendToRole: selectedVendor?.rejectionSendTo ? parseInt(selectedVendor.rejectionSendTo) : null,
            DeptId: selectedVendor?.deptId || null,
            HeadId: selectedVendor?.headId || null
        };

        console.log("Submitting approval payload:", payload);

        try {
            const response = await axios.post(
                "/api/approvalstatus/submit-approval",
                payload
            );

            if (response.status === 200) {
                alert("Approval submitted successfully.");

                setVendors(prev => prev.filter(v => v.id !== selectedVendor.id));
                setShowModal(false);
                setIsEditing(false);
            } else {
                alert("Failed to submit approval.");
            }

        } catch (error) {
            console.error("Error submitting approval:", error.response?.data || error);
            alert("Something went wrong while submitting approval.");
        }
    };

    const handleReject = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            updatedVendors[selectedVendor.index].approvalStatus = "Rejected";
            setVendors(updatedVendors);
        }
        setShowModal(false);
    };

    return (
        <DashboardLayout>
            <div className="vendor-registration-details">
                <Container fluid style={{ marginTop: "-85px", paddingTop: "0" }}>

                    <h2 className="invoice-title" style={{ marginTop: 0, marginBottom: '15px', color: '#0a4275', paddingTop: '50px' }}> Vendor Details</h2>  
                    {/* 🔹 Search & Filter Row */}
                    <div
                        className="vendor-toolbar"
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "nowrap",
                            marginBottom: "20px",
                        }}
                    >
                        {/* LEFT CORNER - SEARCH */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <div
                                className="vendor-search-box invoice-search-box"
                                style={{
                                    width: "350px",
                                }}
                            >
                                <span className="vendor-search-icon">
                                    🔍
                                </span>

                                <Input
                                    type="text"
                                    placeholder="Search by Company Name..."
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    className="vendor-search-input"
                                />
                            </div>
                        </div>

                        {/* RIGHT CORNER - STATUS */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <span style={{ whiteSpace: "nowrap" }}>
                                Approved Status:
                            </span>

                            <select
                                value={selectedStatus}
                                onChange={(e) => {
                                    setSelectedStatus(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                                style={{
                                    width: "180px",
                                    height: "36px",
                                }}
                            >
                                <option value={statusMapping.Pending}>⏳ Pending</option>
                                <option value={statusMapping.Approved}>✔️ Approved</option>
                                <option value={statusMapping.Rejected}>❌ Rejected</option>
                            </select>
                        </div>
                    </div>
                    {/* 🔹 “Company not found” message (under search) */}
                    {searchTerm && vendorsForPage.length === 0 && (
                        <div
                            style={{
                                color: "red",
                                fontWeight: "500",
                                marginBottom: "10px",
                                textAlign: "left", // under search box
                            }}
                        >
                            Company not found
                        </div>
                    )}

                        <Table bordered className="vendor-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Company Name</th>
                                    <th>Contact Person</th>
                                    <th>Nature of Supply</th>
                                    <th>MSME</th>
                                    <th>PAN Number</th>
                                    <th>GST Number</th>
                                    <th>HSN/SAC Code</th>
                                    <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                        Approval Status {sortBy === "approvalStatus"
                                            ? (sortOrder === "asc" ? "▲" : "▼")
                                            : "⇅"}
                                    </th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                        <tbody>
                            {vendorsForPage.length === 0 ? (
                                <tr><td colSpan="10">No pending vendors found.</td></tr>
                            ) : (
                                vendorsForPage.map((vendor, index) => (
                                    <tr key={vendor.vendorCode || index}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{vendor.nameOfCompany}</td>
                                        <td>{vendor.contactPersonName || "N/A"}</td>
                                        <td>{vendor.natureOfSupply}</td>
                                        <td>{vendor.msmeNo || "N/A"}</td>
                                        <td>{vendor.pan || "N/A"}</td>
                                        <td>{vendor.gst || "N/A"}</td>
                                        <td>{vendor.hsNsacCode || "N/A"}</td>
                                        <td>{vendor.approvalStatus || "N/A"}</td>
                                        <td>
                                            <button className="review-btn" onClick={() => handleReviewClick(startIndex + index)}>
                                                Review
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                        </Table>

                        <div className="pagination">
                            <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                            <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                            <span className="page-info">Page {currentPage} of {totalPages}</span>
                            <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                            <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
                        </div>
                    </Container>

                    <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered className="modal-lg custom-modal">
                        <ModalHeader toggle={() => setShowModal(false)}>Vendor Details</ModalHeader>
                        <div className="tabs1">
                            <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Vendor Approval History</span>
                            <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Info</span>
                            <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>

                        </div>
                        <ModalBody>

                            {activeTab === "history" && selectedVendor && ( 
                                <div className="history-container">
                                    <Table bordered className="history-table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Approval Status</th>
                                                <th>Approver Name</th>
                                                <th>Date</th>
                                                <th>Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.length > 0 ? (
                                                users.map((user, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{user.approvalStatus || "N/A"}</td>
                                                        <td>{user.approvalName || "N/A"}</td>
                                                        <td>
                                                            {user.createDate
                                                                ? (() => {
                                                                    const date = new Date(user.createDate);

                                                                    const day = String(date.getDate()).padStart(2, "0");
                                                                    const month = String(date.getMonth() + 1).padStart(2, "0");
                                                                    const year = date.getFullYear();

                                                                    const hours = String(date.getHours()).padStart(2, "0");
                                                                    const minutes = String(date.getMinutes()).padStart(2, "0");
                                                                    const seconds = String(date.getSeconds()).padStart(2, "0");

                                                                    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                                                                })()
                                                                : "N/A"}
                                                        </td>

                                                        <td>{user.comments || "N/A"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No history found</td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </Table>
                                </div>
                            )}    
                            {activeTab === "info" && selectedVendor && (
                                <VendorInfoTabs
                                    selectedVendor={selectedVendor}
                                    isEditing={isEditing}
                                    setIsEditing={setIsEditing}
                                    handleInputChange={handleInputChange}
                                    subTab={subTab}
                                    setSubTab={setSubTab}
                                type="vendor"

                                />
                            )}

                            {activeTab === "details" && selectedVendor && (
                                <div className="details-container">
                                <>
                                        <Table bordered className="info-table1">
                                            <tbody>
                                                <tr>
                                                    <th>Name of Company:</th>
                                                <td>{selectedVendor?.nameOfCompany || "N/A"}</td>

                                            </tr>
                                            
                                                <tr>
                                                    <th>Approval Status:<span className="required-field">*</span></th>
                                                    <td>
                                                    <Input
                                                        type="select"
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.approvalStatus || ""}
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            setSelectedVendor(prev => ({
                                                                ...(prev || {}),
                                                                approvalStatus: value,
                                                                rejectionSendTo: value === "Rejected" ? prev?.rejectionSendTo || "" : ""
                                                            }));
                                                            setApprovalStatusError("");
                                                        }}
                                                        disabled={backendStatus !== "Pending"}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Approved">Approved</option>
                                                        <option value="Rejected">Rejected</option>
                                                    </Input>

                                                    {approvalStatusError && <div className="text-danger">{approvalStatusError}</div>}
                                                    </td>
                                                   
                                                <th>Comments:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="textarea"
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.comments || ""}
                                                        onChange={(e) => {
                                                            setSelectedVendor({ ...selectedVendor, comments: e.target.value });
                                                            setCommentError(""); // ✔ cleared correctly
                                                        }}
                                                        placeholder="Enter your comment..."
                                                        disabled={selectedVendor?.isReadOnly}
                                                    />
                                                    {commentError && <div className="text-danger">{commentError}</div>}
                                                </td>


                                                </tr>
                                                <tr>
                                                    <th>Rejection Send To:<span className="required-field">*</span></th>
                                                    <td>
                                                    <Input
                                                        type="select"
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.rejectionSendTo || ""}
                                                        onChange={(e) => {
                                                            setSelectedVendor({ ...selectedVendor, rejectionSendTo: e.target.value });
                                                            setRejectionSendToError("");
                                                        }}
                                                      // {/* disabled={selectedVendor?.approvalStatus !== "Rejected"}*/}
                                                        disabled={selectedVendor?.isReadOnly || selectedVendor?.approvalStatus !== "Rejected"}
                                                    >
                                                        <option value="">Select Role</option>
                                                        <option value="4">PO</option>
                                                        <option value="5">Vendor</option>
                                                    </Input>

                                                        {rejectionSendToError && (
                                                            <div className="text-danger">{rejectionSendToError}</div>
                                                        )}
                                                    </td>
                                                </tr>
                                            
                                            </tbody>
                                        </Table>
                                    <ModalFooter>
                                        {!selectedVendor?.isReadOnly && (   // <-- hides when Approved/Rejected
                                            <Button color="success" onClick={handleSave}>
                                                Save
                                            </Button>
                                        )}

                                        <Button color="danger" onClick={() => setShowModal(false)}>
                                            Close
                                        </Button>
                                    </ModalFooter>

                                    </>
                                </div>
                        )}
                        </ModalBody>
                    </Modal>
                </div>
        </DashboardLayout>
    );
};
export default ViewAllVendorsDeptHead;

